{
  "app.metaDescription": "En lokal aktieportfölj byggd med Deno och BedrockJS.",
  "app.promoLead": "Vill du ha en bättre budgetapp?",
  "app.promoLink": "Testa Sambokoll",
  "app.home": "Till översikten",
  "app.subtitle": "portfölj på enheten",
  "app.loading": "Laddar lokal portfölj...",

  "nav.overview": "Översikt",
  "nav.holdings": "Innehav",
  "nav.transactions": "Transaktioner",
  "nav.search": "Sök",
  "nav.settings": "Inställningar",

  "language.label": "Språk",
  "language.menu": "Välj språk",
  "language.loadFailed": "Kunde inte ladda {language}. Försök igen.",

  "currency.label": "Valuta",
  "currency.display": "Visningsvaluta",
  "currency.showIn": "Visa portföljen i {currency}",

  "refresh.idle": "Uppdatera",
  "refresh.busy": "Uppdaterar",
  "refresh.never": "ej uppdaterad",

  "common.close": "Stäng",
  "common.cancel": "Avbryt",
  "common.delete": "Ta bort",
  "common.today": "{percent} idag",
  "common.avg": "snitt {price}",
  "common.inclFees": "inkl. avgifter",
  "common.noSales": "inga försäljningar",
  "common.waitingForPrice": "väntar på kurs",

  "action.sell": "Sälj",
  "action.sellHolding": "Sälj innehav",

  "trade.buy": "Köp",
  "trade.sell": "Sälj",
  "trade.sharesAt": "{shares} à {price}",

  "units.shares": {
    "one": "{count} st",
    "other": "{count} st"
  },
  "count.buys": {
    "one": "{count} köp",
    "other": "{count} köp"
  },
  "count.sales": {
    "one": "{count} försäljning",
    "other": "{count} försäljningar"
  },
  "count.holdings": {
    "one": "{count} innehav",
    "other": "{count} innehav"
  },
  "count.skipped": {
    "one": "{count} ogiltig post hoppades över",
    "other": "{count} ogiltiga poster hoppades över"
  },

  "label.quantity": "Antal",
  "label.date": "Datum",
  "label.note": "Anteckning",
  "label.price": "Kurs",
  "label.priceNow": "Kurs nu",
  "label.holding": "Innehav",
  "label.averageCost": "Snittkurs",
  "label.inclFeesIn": "inkl. avgifter, i {base}",
  "label.realized": "Realiserat",
  "label.unrealized": "Orealiserat",
  "label.cost": "Kostnad",
  "label.proceeds": "Erhållet",

  "form.symbol": "Aktiesymbol",
  "form.searching": "Söker...",
  "form.pricePerShare": "Pris per aktie",
  "form.fetch": "Hämta",
  "form.fees": "Avgifter ({currency})",
  "form.fxRate": "Växelkurs · {base} per {currency}",
  "form.symbolFirst": "Ange en aktiesymbol först.",
  "form.invalidFxRate": "Ange växelkursen ({base} per {currency}).",

  "dashboard.portfolioValue": "Portföljvärde",
  "dashboard.unrealizedDelta": "{amount} · {percent} orealiserat",
  "dashboard.dayChange": "Dagens rörelse",
  "dashboard.noSalesYet": "inga försäljningar ännu",
  "dashboard.costBasis": "Anskaffningsvärde",
  "dashboard.totalReturn": "Totalt resultat",
  "dashboard.totalReturnNote": "realiserat + orealiserat · {updated}",
  "dashboard.holdingsTitle": "Innehav",
  "dashboard.holdingsIntro": "Öppna positioner sorterade efter marknadsvärde. Sälj hela eller delar av ett innehav direkt från raden.",
  "dashboard.noHoldings": "Inga öppna innehav ännu.",
  "dashboard.holdingsEmpty": "Lägg till ditt första köp för att börja följa resultatet.",
  "dashboard.addTitle": "Lägg till köp",
  "dashboard.addIntro": "Registrera symbol, antal och pris i affärens valuta. Växelkursen på köpdagen hämtas automatiskt.",
  "dashboard.allocationTitle": "Fördelning",
  "dashboard.allocationIntro": "Aktuell vikt baserad på marknadsvärde.",
  "dashboard.allocationEmpty": "Fördelningen visas efter minst ett sparat köp.",
  "dashboard.moversTitle": "Utveckling",
  "dashboard.moversIntro": "Bästa och svagaste orealiserade avkastning.",
  "dashboard.best": "Bäst",
  "dashboard.worst": "Svagast",
  "dashboard.moversEmpty": "Utveckling visas när kurserna har laddats.",
  "dashboard.realizedTitle": "Realiserat per innehav",
  "dashboard.realizedIntro": "Resultat från försäljningar enligt genomsnittsmetoden.",
  "dashboard.allTransactions": "Alla transaktioner",
  "dashboard.realizedEmpty": "Här samlas resultatet när du säljer hela eller delar av ett innehav.",

  "lot.invalidInput": "Ange en aktiesymbol och ett positivt antal aktier.",
  "lot.invalidPrice": "Ange köppriset per aktie i {currency}.",
  "lot.saved": "Sparade {shares} {symbol} à {price}.",
  "lot.savedConverted": "Sparade {shares} {symbol} à {price} ({converted}).",
  "lot.notePlaceholder": "Mäklare, tes, konto",
  "lot.busy": "Hämtar",
  "lot.submit": "Spara köp",
  "lot.total": "Totalt {amount}",

  "sell.title": "Sälj {symbol}",
  "sell.intro": "Registrera en hel eller delvis försäljning. Resultatet räknas i {base} med genomsnittsmetoden.",
  "sell.noHoldings": "Du har inga öppna innehav att sälja ännu.",
  "sell.emptyHint": "Registrera ett köp först, sedan kan du sälja hela eller delar av innehavet här.",
  "sell.chooseHolding": "Välj ett innehav att sälja.",
  "sell.invalidQuantity": "Ange hur många aktier du sålde.",
  "sell.invalidDate": "Ange ett giltigt försäljningsdatum.",
  "sell.onlyAvailable": {
    "one": "Du hade bara {count} aktie i {symbol} tillgänglig {date}.",
    "other": "Du hade bara {count} aktier i {symbol} tillgängliga {date}."
  },
  "sell.noneAvailable": "Du hade inga aktier i {symbol} att sälja {date}.",
  "sell.invalidPrice": "Ange försäljningspriset per aktie i {currency}.",
  "sell.negativeFees": "Avgifter kan inte vara negativa.",
  "sell.notice": "Sålde {shares} {symbol} för {amount}. Realiserat resultat {gain} ({percent}).",
  "sell.quantity": "Antal att sälja",
  "sell.available": "Tillgängligt {shares}",
  "sell.availableOn": "Tillgängligt {shares} den {date}",
  "sell.nothingAvailable": "Inget tillgängligt att sälja",
  "sell.nothingAvailableOn": "Inget tillgängligt den {date}",
  "sell.quickPicks": "Snabbval",
  "sell.all": "Allt",
  "sell.notePlaceholder": "Mäklare, anledning, konto",
  "sell.netProceeds": "Erhållet netto",
  "sell.afterFees": "efter {amount} i avgifter",
  "sell.proceedsFormula": "pris × antal − avgifter",
  "sell.costBasis": "Anskaffning",
  "sell.costFormula": "{shares} × {price} snitt",
  "sell.averageMethod": "genomsnittsmetoden",
  "sell.realizedResult": "Realiserat resultat",
  "sell.enterQuantityPrice": "fyll i antal och pris",
  "sell.remaining": "Kvar efteråt",
  "sell.positionCloses": "positionen avslutas",
  "sell.unchanged": "oförändrat",
  "sell.maxQuantity": "Du kan sälja högst {shares}.",
  "sell.saving": "Sparar",
  "sell.submitCount": {
    "one": "Sälj {count} aktie",
    "other": "Sälj {count} aktier"
  },

  "range.1mo": "1M",
  "range.3mo": "3M",
  "range.6mo": "6M",
  "range.1y": "1Å",
  "range.2y": "2Å",
  "range.5y": "5Å",

  "holdings.title": "Innehav",
  "holdings.intro": "Välj ett innehav för att se kursen med dina köp och försäljningar.",
  "holdings.filter": "Filtrera på symbol eller namn",
  "holdings.scope": "Urval",
  "holdings.scopeOpen": "Öppna",
  "holdings.scopeClosed": "Avslutade",
  "holdings.noMatch": "Inget innehav matchar filtret.",
  "holdings.empty": "Lägg till ett köp på översikten för att se det här.",
  "holdings.choose": "Välj ett innehav i listan.",
  "holdings.listedIn": "noterad i {currency}",
  "holdings.closedPosition": "Avslutad position",
  "holdings.watched": "Bevakad",
  "holdings.noOpenPosition": "ingen öppen position",
  "holdings.closedResult": "avslutad · {amount}",
  "holdings.range": "Tidsintervall",
  "holdings.tradesTitle": "Affärer i {symbol}",
  "holdings.tradesIntro": "Kursen sedan varje affär – stigande kurs efter köp och fallande efter sälj är bra tajming.",
  "holdings.noTrades": "Inga affärer registrerade för det här innehavet.",

  "filter.all": "Alla",

  "chart.label": "{symbol} kursdiagram med köp och försäljningar",
  "chart.legendClose": "Stängningskurs ({currency})",
  "chart.loadFailed": "Kunde inte hämta kurshistorik: {error}",
  "chart.loading": "Hämtar kurshistorik...",
  "chart.noData": "Ingen kurshistorik tillgänglig för intervallet.",
  "chart.duringPeriod": "under perioden",
  "chart.high": "högst {price}",
  "chart.low": "lägst {price}",
  "chart.outside": {
    "one": "{count} affär ligger före intervallet, välj ett längre",
    "other": "{count} affärer ligger före intervallet, välj ett längre"
  },
  "chart.updating": "uppdaterar...",
  "chart.buyAt": "Köp {shares} à {price}",
  "chart.sellAt": "Sälj {shares} à {price}",
  "chart.converted": "(omräknat)",

  "timing.unchanged": "oförändrad kurs sedan affären",
  "timing.risenSinceBuy": "kursen har stigit sedan köpet",
  "timing.fallenSinceBuy": "kursen har fallit sedan köpet",
  "timing.goodSell": "bra tajming – kursen har fallit sedan",
  "timing.risenSinceSell": "kursen har stigit sedan försäljningen",
  "timing.outsideChart": "utanför diagrammet",
  "timing.priceSince": "Kurs sedan affären",

  "position.trend": "{symbol} pristrend",
  "position.price": "Pris",
  "position.value": "Värde",
  "position.realizedAmount": "{amount} realiserat",
  "position.result": "Resultat",

  "transactions.title": "Transaktioner",
  "transactions.intro": "Köp och försäljningar sparas lokalt i IndexedDB, i affärens valuta med växelkursen på affärsdagen. Resultatet räknas i {base} mot snittkursen vid tillfället (genomsnittsmetoden).",
  "transactions.invested": "Investerat",
  "transactions.soldFor": "Sålt för",
  "transactions.type": "Typ",
  "transactions.symbolFilter": "Filtrera på symbol",
  "transactions.allSymbols": "Alla symboler",
  "transactions.noMatch": "Inga transaktioner matchar filtret.",
  "transactions.empty": "Inga transaktioner har sparats. Lägg till ett köp på översikten.",
  "transactions.fee": "avgift {amount}",
  "transactions.priceSinceBuy": "Kurs sedan köp",
  "transactions.now": "nu {price}",

  "research.title": "Sök",
  "research.intro": "Sök Yahoo Finance-symboler och lägg till dem i din lokala bevakningslista.",
  "research.placeholder": "Sök bolag eller aktiesymbol",
  "research.search": "Sök",
  "research.searching": "Söker",
  "research.noResults": "Inga matchande tickers hittades.",
  "research.watch": "Bevaka",
  "research.watching": "{symbol} bevakas nu lokalt.",
  "research.watchedTitle": "Bevakade symboler",
  "research.watchedIntro": "Bevakningslista och innehav med lokalt cachade kursbilder.",
  "research.watchedEmpty": "Sök och bevaka en symbol, eller spara ett köp.",

  "watch.added": "{symbol} bevakas på den här enheten.",
  "watch.closed": "Avslutad",
  "watch.stop": "Sluta bevaka",
  "watch.chart": "{symbol} diagram",
  "watch.last": "Senast",
  "watch.change": "Rörelse",
  "watch.updated": "Uppdaterad",
  "watch.waiting": "Väntar",

  "realized.sold": {
    "one": "{count} såld",
    "other": "{count} sålda"
  },
  "realized.remaining": {
    "one": "{count} kvar",
    "other": "{count} kvar"
  },
  "realized.closed": "positionen avslutad",

  "settings.localTitle": "Lokal data",
  "settings.localIntro": "Köp, försäljningar och bevakningar stannar i den här webbläsarens IndexedDB.",
  "settings.export": "Exportera JSON",
  "settings.import": "Importera JSON",
  "settings.persist": "Beständig lagring",
  "settings.clear": "Rensa lokal data",
  "settings.imported": "Importerade {buys} och {sales}.",
  "settings.importedSkipped": "Importerade {buys} och {sales} · {skipped}.",
  "settings.confirmClear": "Ta bort all lokal Stockroom-data från den här webbläsaren?",
  "settings.cleared": "Lokal data rensad.",
  "settings.persistUnavailable": "Beständig webbläsarlagring är inte tillgänglig här.",
  "settings.persistGranted": "Webbläsaren beviljade beständig lagring.",
  "settings.persistDenied": "Webbläsaren beviljade inte beständig lagring.",
  "settings.storageTitle": "Lagring",
  "settings.storageIntro": "Antalen nedan är lokala poster, inte serverposter.",
  "settings.currencyTitle": "Valuta",
  "settings.currencyIntro": "Affärer bokförs i {base} med växelkursen på affärsdagen. Visningsvalutan räknar om hela portföljen med aktuell kurs.",
  "settings.ratesHint": "Växelkurser hämtas från Yahoo Finance när de behövs.",

  "stats.buys": {
    "one": "köp",
    "other": "köp"
  },
  "stats.sales": {
    "one": "försäljning",
    "other": "försäljningar"
  },
  "stats.watched": {
    "one": "bevakad symbol",
    "other": "bevakade symboler"
  },
  "stats.quotes": {
    "one": "kursbild",
    "other": "kursbilder"
  },
  "stats.histories": {
    "one": "kurshistorik synkad från servern",
    "other": "kurshistoriker synkade från servern"
  },

  "lookup.close": "Stängningskurs {date} för {symbol}: {price}",
  "lookup.latest": "Senaste kurs för {symbol}: {price}",
  "lookup.currentRate": "(aktuell kurs)",

  "confirm.deleteBuy": "Ta bort köpet av {shares} {symbol} ({date})?",
  "confirm.deleteSale": "Ta bort försäljningen av {shares} {symbol} ({date})? Aktierna räknas då som ägda igen.",

  "import.invalid": "Importfilen är inte giltig JSON.",
  "import.noBuys": "Importfilen saknar köp.",
  "import.badSales": "Importfilens försäljningar har fel format.",
  "import.noWatchlist": "Importfilen saknar bevakningslista.",

  "errors.symbolMissing": "Aktiesymbol saknas",
  "errors.noQuote": "Ingen kurs hittades för {symbol}",
  "errors.fxRate": "Kunde inte hämta växelkurs för {currencies} till {base}.",
  "errors.requestFailed": "Förfrågan misslyckades med {status}",
  "errors.timeout": "Förfrågan om marknadsdata tog för lång tid",
  "errors.historyFailed": "Kurshistorik för {symbol} kunde inte hämtas ({status})",

  "server.serverError": "Oväntat serverfel",
  "server.methodNotAllowed": "Metoden stöds inte",
  "server.notFound": "Hittades inte",
  "server.readOnly": "Kurshistoriken kan bara läsas",
  "server.symbolMissing": "Symbol saknas",
  "server.rateLimited": "För många förfrågningar, försök igen om en stund.",
  "server.noMarketData": "Hittade ingen marknadsdata för {symbol}",
  "server.upstreamTimeout": "Marknadsdata svarade inte i tid",
  "server.upstreamUnreachable": "Marknadsdata kunde inte nås",
  "server.upstreamUnavailable": "Marknadsdata är inte tillgänglig just nu"
}
